import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { skills } from '../data/content';
export function SkillsSection() {
  return <section className="w-full bg-ink-950 py-16 sm:py-20" aria-labelledby="dominar-title" data-id="element-125" data-mp="2zbduinwpg28f">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-126" data-mp="3860tp2brzic8">
        <h2 id="dominar-title" className="text-center font-display text-3xl font-bold uppercase text-white sm:text-4xl" data-id="element-127" data-mp="385isrse64fxz">
          Lo que vas a <span className="text-amber-brand" data-id="element-128" data-mp="2gecp51z8o03y">dominar</span>
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-129" data-mp="2kgfz1m69ewn4">
          {skills.map((skill, index) => <motion.li key={skill.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.07
        }} className="flex gap-4 rounded-xl border border-amber-brand/20 bg-ink-900 p-6" data-id="element-130" data-mp="2pfj7lglg7kzu" data-mpi={index}>
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-amber-brand text-ink-950" data-id="element-131" data-mp="3otruo29gehpk">
                <CheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-132" data-mp="3exevwpz1xdny" />
              </span>
              <div data-id="element-133" data-mp="39ylptim3goxt">
                <h3 className="font-display text-xl font-bold uppercase text-white" data-id="element-134" data-mp="39z3mggco5569">
                  {skill.title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-white/60" data-id="element-135" data-mp="35yjppdw0c3kn">
                  {skill.text}
                </p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}